import { ALIGN_CLASSES_INVERSE as o, MENTION_CLASS as c, NO_MARGIN_CLASS as m } from "./constants.js";
import { decodeAttributes as d } from "./utils/attribute-encoding.js";
import { BlockListParser as p, DocumentHtmlEntityDecoder as u } from "@intercom/interblocks.ts";
class b {
  schema;
  documentBuilder;
  blockAttrs;
  markMap;
  nodeMap;
  marks = ["b", "i", "a", "code", "u", "span"];
  nodes = ["p", "br", "ol", "ul", "li", "h1", "h2", "h3", "h4", "small", "pre", "img"];
  customInlineHandlers;
  config;
  constructor(e, t) {
    this.documentBuilder = e, this.config = t, this.schema = e.schema, this.markMap = {
      b: this.schema.marks.bold,
      i: this.schema.marks.italic,
      a: this.schema.marks.anchor,
      code: this.schema.marks.code,
      u: this.schema.marks.underline,
      span: this.schema.marks.span
    }, this.nodeMap = {
      p: this.schema.nodes.paragraph,
      ol: this.schema.nodes.orderedList,
      ul: this.schema.nodes.unorderedList,
      li: this.schema.nodes.listItem,
      h1: this.schema.nodes.heading,
      h2: this.schema.nodes.subheading,
      h3: this.schema.nodes.subheading3,
      h4: this.schema.nodes.subheading4,
      small: this.schema.nodes.small,
      pre: this.schema.nodes.codeBlock,
      br: this.schema.nodes.hardBreak,
      hr: this.schema.nodes.horizontalLine,
      template: this.schema.nodes.template,
      mention: this.schema.nodes.mention,
      aiPromptData: this.schema.nodes.aiPromptData,
      img: this.schema.nodes.inlineImage
    }, this.customInlineHandlers = t.customInlineHandlers ?? [];
    for (const i of this.customInlineHandlers)
      this.nodeMap[i.name] = this.schema.nodes[i.name];
  }
  handle(e, t) {
    p.parse(
      [e],
      new u(document),
      !!this.nodeMap.template,
      this.config.isPlaintext,
      !0,
      !1,
      !1
    ).body.forEach((s) => this.handleNode(s, t));
  }
  handleNode(e, t) {
    if (e.isElement) {
      for (const i of this.customInlineHandlers)
        if (i.detect(e)) {
          i.parse(e, this);
          return;
        }
      if (this.isMention(e))
        this.mention(e);
      else if (this.isAiPromptData(e))
        this.aiPromptData(e);
      else if (this.marks.includes(e.value ?? ""))
        this.mark(e);
      else if (this.nodes.includes(e.value ?? ""))
        this.node(e, t);
      else
        throw new Error(`unknown element type: ${e.value}`);
    } else e.isLiteral ? this.documentBuilder.addText(e.value ?? "") : e.type === "Template" ? this.template(e) : (this.stashBlockAttrs(e), this.handleChildren(e.children ?? [], t));
  }
  node(e, t) {
    const i = this.nodeMap[e.value ?? ""];
    if (!i)
      return;
    const s = this.collectAttrs(e), a = this.consumeBlockAttrs();
    if (this.addAlignment(s, a), this.addStyle(s), i === this.nodeMap.img) {
      const r = e.attributes?.find((n) => n.name === "alt");
      r && (s.text = r.value);
      const l = e.attributes?.find((n) => n.name === "data-class-name");
      l && (s.className = l.value);
    }
    if (this.documentBuilder.openNode(i, s), i === this.nodeMap.li) {
      const r = this.nodeMap.p;
      this.documentBuilder.openNode(r, {});
    }
    this.handleChildren(e.children ?? [], t), i === this.nodeMap.li && this.documentBuilder.closeNode(), this.documentBuilder.closeNode(), this.addExtraParagraphIfLegacyParagraph(e, a, t);
  }
  mark(e) {
    const t = this.markMap[e.value ?? ""];
    let i;
    t && this.documentBuilder.top().type.allowsMarkType(t) && (i = t.create(this.collectAttrs(e)), this.documentBuilder.openMark(i), t === this.markMap.a && this.handleInlineImageLinkUrl(i, e)), this.handleChildren(e.children ?? []), i && this.documentBuilder.closeMark(i);
  }
  mention(e) {
    const t = this.collectAttrs(e);
    this.nodeMap.mention && (this.documentBuilder.openNode(this.nodeMap.mention, {
      name: e.children?.[0]?.value ?? "",
      uri: t.href
    }), this.documentBuilder.closeNode());
  }
  aiPromptData(e) {
    let t = this.collectAttrs(e);
    const i = {};
    for (const [s, a] of Object.entries(t))
      if (typeof s == "string" && s.startsWith("data-prompt-data-")) {
        const l = s.split("-").slice(3).map((n, h) => h === 0 ? n : n.charAt(0).toUpperCase() + n.slice(1)).join("");
        i[l] = String(a);
      }
    t = i, this.nodeMap.aiPromptData && (this.documentBuilder.openNode(this.nodeMap.aiPromptData, t), this.documentBuilder.closeNode());
  }
  template(e) {
    this.nodeMap.template && (this.documentBuilder.openNode(this.nodeMap.template, {
      attributePath: e.value ?? "",
      fallback: e.fallback ?? ""
    }), this.documentBuilder.closeNode());
  }
  handleInlineImageLinkUrl(e, t) {
    if (t.children?.length === 1 && t.children[0]?.value === "img") {
      const i = e.attrs.href ?? "";
      t.children[0].attributes?.push({
        type: "Attribute",
        name: "linkUrl",
        value: i
      });
    }
  }
  collectAttrs(e) {
    const t = {};
    return e.attributes?.forEach((i) => {
      const s = d(i.value);
      t[i.name] ? t[i.name] += ` ${s}` : t[i.name] = s;
    }), e.type === "Block" && (t.type = e.value), e.isElement && e.id && (t.idAttribute = e.id), t;
  }
  stashBlockAttrs(e) {
    this.blockAttrs = this.collectAttrs(e);
  }
  consumeBlockAttrs() {
    const e = this.blockAttrs;
    return this.blockAttrs = void 0, e;
  }
  addAlignment(e, t) {
    !t || typeof t.class != "string" || t.class.split(" ").forEach((i) => {
      const s = o[i];
      s && Object.assign(e, { alignment: s });
    });
  }
  addStyle(e) {
    !e || typeof e.style != "string" || e.style.split(";").forEach((t) => {
      if (!t)
        return;
      const i = t.split(":", 2), s = i[0], a = i[1].trim();
      s === "font-family" && Object.assign(e, { fontFamily: a }), s === "color" && Object.assign(e, { fontColor: a }), s === "width" && Object.assign(e, { width: a.replace("px", "") });
    });
  }
  handleChildren(e, t) {
    e.forEach((i) => {
      this.handleNode(i, t);
    });
  }
  isMention(e) {
    return !!(this.nodeMap.mention && e.value === "a" && e.attributes?.find((t) => t.name === "class" && t.value === c));
  }
  isAiPromptData(e) {
    return !!(this.nodeMap.aiPromptData && e.value === "span" && e.attributes?.find((t) => t.name === "data-ai-prompt-data"));
  }
  addExtraParagraphIfLegacyParagraph(e, t, i) {
    this.isParagraphWithImplicitMargin(e, t, i) && !this.config.singleBlockMode && !this.config.allowImplicitMarginParagraphs && (this.documentBuilder.openNode(this.nodeMap.p, {}), this.documentBuilder.closeNode());
  }
  isParagraphWithImplicitMargin(e, t, i) {
    return !t || !i ? !1 : e.value === "p" && !t.class.includes(m);
  }
}
export {
  b as TextBlockParser
};
